import { render, staticRenderFns } from "./tradesmanList.vue?vue&type=template&id=9ff14890&scoped=true&"
import script from "./tradesmanList.vue?vue&type=script&lang=js&"
export * from "./tradesmanList.vue?vue&type=script&lang=js&"
import style0 from "./tradesmanList.vue?vue&type=style&index=0&id=9ff14890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff14890",
  null
  
)

export default component.exports